import { createMuiTheme } from '@material-ui/core';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import Background from './assets/background.png';

const primary = '#6A148E';
const breakpoints = createBreakpoints({});

const MainTheme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 719,
      lg: 960,
      xl: 1280,
    },
  },
  palette: {
    primary: {
      light: '#8A2BE2',
      main: primary,
      dark: '#32174A',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#464646',
      contrastText: primary,
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        [breakpoints.up('md')]: {
          body: {
            backgroundImage: `url(${Background})`,
            backgroundAttachment: 'fixed',
            backgroundRepeat: 'repeat-x repeat-y',
          },
        },
        [breakpoints.down('md')]: {
          body: {
            background: 'white',
          },
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderRadius: '5px 5px 0 0',
        },
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: '0 0 5px 5px',
      },
    },
    MuiListItem: {
      root: {
        '&.Mui-selected': {
          backgroundColor: primary,
          color: '#FFFFFF',
        },
        '&.Mui-selected:hover': {
          color: 'black',
        },
      },
    },
    MuiSelect: {
      root: {
        backgroundColor: 'white',
      },
    },
    MuiFormControl: {
      root: {
        marginTop: '24px',
      },
    },
    MuiTextField: {
      root: {
        backgroundColor: 'white',
        marginTop: '24px',
      },
    },
    MuiButton: {
      root: {
        height: 40,
        fontSize: 16,
      },
      outlinedSecondary: {
        '&:hover': {
          backgroundColor: '#d9d9d9',
        },
        color: '#464646',
      },
    },
    MuiTypography: {
      h1: {
        fontSize: 30,
        fontWeight: 'bold',
      },
      h2: {
        fontSize: 20,
      },
      h3: {
        fontSize: 17,
      },
      h4: {
        fontSize: 16,
      },
      h5: {
        fontSize: 14,
      },
      h6: {
        fontSize: 13,
      },
      subtitle1: {
        fontSize: 13,
        fontWeight: 'bold',
      },
      subtitle2: {
        fontSize: 10,
        fontWeight: 'bold',
      },
      body1: {
        fontSize: 12,
      },
      body2: {
        fontSize: 10,
      },
      colorTextPrimary: {
        color: '#FFFFFF',
      },
    },
  },
  typography: {
    fontFamily: [
      'Barlow',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    button: {
      textTransform: 'none',
    },
  },
});

export default MainTheme;
